<nav 
    #topbarContainer 
    id="Topbar" 
    class="pointer-events-auto w-full flex justify-between items-center h-14 relative md:static" 
    role="navigation" 
    aria-label="Main navigation"
>

    <!-- BUTTONS & MENUS -->
    <div class="w-[34px] md:w-1/3 flex items-center gap-x-2">

        <!-- LEFT BUTTONS -->
        <app-navigation/>

        <!-- MENU -->
        @if(!isMobile()){
         
        <app-menu/>
        
        }

    </div>

    <!-- TITLE AND NEIGHBORS -->
    <div class="md:w-1/3">
        <app-event-title/>
        <app-neighbors/>
    </div>

    <!-- OTROS -->
    <div class="w-[34px] md:w-1/3 flex md:justify-end md:gap-x-2">
        
        <!-- <app-button [label]="'Configurations'"/>
        <app-button [label]="'Benefits'"/> -->
        @if(!isMobile()){
            <app-benefits />
        }

        <app-legend/>

        @if(!isMobile()){
            <app-hyperlink/>
        }

        <app-fullscreen-toggle/>

    </div>
    

    <!-- ACTION BUTTONS MOBILE -->
    <div class="md:hidden relative contents left-0 top-full">
       
        <div class="absolute left-0 top-full">
            <app-link-action-buttons/>
        </div>

        <div class="absolute right-0 top-full">
            <app-hyperlink/>
        </div>
        
    </div>

</nav>